import './styles.scss';
import React, {useEffect, useState} from "react";

import Utils from "../../utils";
import {NavLink} from "react-router-dom";
import { Button } from 'react-bootstrap';

interface IProps  {
  label: string;
  link?: string;
  icon?:string;
  disabled?:boolean;
}

const TextLink = (props: IProps):JSX.Element => {
  const {
    label,
    icon,
    disabled
  } = props;

  const link:string = (props.link?.substring(0,4) === 'www.') ? Utils.addProtocol(props.link) : props.link;

  // eslint-disable-next-line
  const [iconClasses, setIconClasses] = useState(null);

  useEffect(()=>{
    if (!icon) return;

    const bsClass = (): string | null => {
      switch (icon) {
        case 'external':
          return ' ms-2 bi bi-box-arrow-up-right'

        case 'pdf':
          return ' ms-1 bi bi-file-earmark-pdf';

        case 'doc':
          return ' ms-1 bi bi-file-earmark';

        default:
          return null
      }
    }
    setIconClasses( bsClass() )

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [icon])

  return (
    <NavLink to={link}>
      <Button
        disabled = {disabled}
        className={'bg-transparent border-0 text-link btn' + (disabled ? ' disabled': '')}>
        <div className={'label text-start text-decoration-underline'}>
          {label}
        </div>
      </Button>
    </NavLink>
  )
}

export default TextLink;
